import { type ReactNode, useMemo } from "react";

import clsx from "clsx";
import { Button } from "react-aria-components";

import { ArrowNextIcon } from "../../../icons/arrow-next";
import { ArrowPrevIcon } from "../../../icons/arrow-prev";

import styles from "./table-pagination.module.css";

type TablePaginationProps = {
	currentPage?: number;
	isEmptyState: boolean;
	isNextDisabled?: boolean;
	isPrevDisabled?: boolean;
	onPageNavigation: (dir: "next" | "prev") => void;
	totalPages?: number;
};

export function TablePagination({
	currentPage,
	isEmptyState,
	isNextDisabled,
	isPrevDisabled,
	onPageNavigation,
	totalPages,
}: TablePaginationProps): ReactNode {
	const displayTotalPages = useMemo(() => {
		return totalPages && totalPages > 1000 ? "+1000" : totalPages;
	}, [totalPages]);

	if (isEmptyState) {
		return null;
	}

	return (
		<div className={styles.navigationAndIndicator}>
			<div className={styles.pageNavigation}>
				<Button
					data-testid="prev-button"
					isDisabled={isPrevDisabled}
					onPress={() => {
						return onPageNavigation("prev");
					}}
				>
					<ArrowPrevIcon />
				</Button>
				<Button
					data-testid="next-button"
					isDisabled={isNextDisabled}
					onPress={() => {
						return onPageNavigation("next");
					}}
				>
					<ArrowNextIcon />
				</Button>
			</div>
			{Boolean(currentPage) && (
				<span className={clsx(styles.pageIndicator, "body-2")} data-testid="page-indicator">
					{currentPage}
					{Boolean(totalPages) && (
						<span className={styles.totalPages}> - {displayTotalPages}</span>
					)}
				</span>
			)}
		</div>
	);
}
